export const SHOW_ERROR_LOAD_DELAY = 15000;

export const APP_NAME = "Data Manager";

export const MAINTENANCE_TEAM_NAME = "Insights Portal support";
export const MAINTENANCE_TEAM_EMAIL = "insightsportal@materialplus.io";

export const DATAMANAGER_ADMIN_EMAIL = "datamanageradmin@materialplus.io";

export const HELPDESK_LINK = "https://material.freshservice.com/support/tickets/new";
export const BULK_INCLUDE_EXCLUDE_HELPDESK_LINK = "https://material.freshservice.com/support/solutions/articles/22000095160";
export const HELPDESK = "Helpdesk";

export const HELPDESK_LINK_TOKEN = "HELPDESK_LINK";
export const PLATFORM_LINK_TOKEN = "PLATFORM_LINK";

export const DATA_FILE_UPLOAD_TIME_OUT = 10800000; //10800000 in ms = 3 hours
